import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { AddExpensePage } from '@/areas/manufacturing-templates/Expenses/ExpensesCreation/AddExpensePage';
import { canCreateManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/manufacturing/expenses/create')({
    staticData: { access: { permissions: canCreateManufacturingTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <AddExpensePage />;
}
